export default __webpack_public_path__ + "static/media/africa.a4dd7e8d.png";